import React from 'react';
import imagePlayButton from '../../assets/play_button.png';
import imagePauseButton from '../../assets/pause_button.png';
import { Howl } from 'howler';
import imageLoadButton from '../../assets/loading_icon.png';

class Audio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      paused: true,
      degrees: 0
    }; 

    this.onPlay = this.onPlay.bind(this);

    this.playerMap = {};
    this.updatePlayerMap();

    this.tick = this.tick.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.current_song.song_url !== this.props.current_song.song_url) {
      this.currentPlayer.pause();
    }  
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.current_playlist.id !== this.props.current_playlist.id) {
      this.updatePlayerMap();
    }
    if (prevProps.current_song.song_url !== this.props.current_song.song_url) {
      this.playCurrentPlayer();
    }

    this.updatePlayerMap();

    if (this.stoppedLoadingAudios) {
      this.loadNextAudio();
    }
  }

  tick() {
    const degrees = this.state.degrees + 3;
    this.setState({
      degrees
    });
    this._tickTimer = requestAnimationFrame(this.tick);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this._tickTimer);
  }

  componentDidMount() {
    this.playCurrentPlayer();
    this.loadNextAudio();
    this.tick();
  }

  loadNextAudio() {
    this.stoppedLoadingAudios = false;

    for (let id in this.playerMap) { 
      const player = this.playerMap[id].player;
      if (player.state() !== 'loaded') {
        this.loadAudio(player);
        return;
      }
    }

    this.stoppedLoadingAudios = true;
  }

  loadAudio(player) {
    player.load();
    player.once('load', () => {
      this.loadNextAudio();
    });
  }

  playCurrentPlayer() {
    if (this.currentPlayer.state() !== 'loaded') {
      this.currentPlayer.once('load', () => {
        this.currentPlayer.play();
      });
      return;
    }
    this.currentPlayer.play();
  }

  onPlay() {
    if (this.state.paused) {
      this.playCurrentPlayer();
    } else {
      this.currentPlayer.pause();
    }
  }

  get currentPlayer() {
    if (this.playerMap[this.props.current_song.id] == null) {
      return null;
    }
    return this.playerMap[this.props.current_song.id].player;
  }

  get currentPlayerPlayed() {
    return this.playerMap[this.props.current_song.id].played;
  }

  updatePlayerMap() {
    for (let i = 0; i < this.props.current_playlist.survey_playlist_files.length; i++) {
      this.updatePlayer(this.props.current_playlist.survey_playlist_files[i]);
    }
  }

  updatePlayer(audio) {
    if (this.playerMap[audio.id] == null) {
      this.playerMap[audio.id] = {
        player: this.createPlayer(audio)
      }
    }
  }

  createPlayer(audio) {
    const player = new Howl({
      src: [ audio.song_url ],
      preload: audio.id === this.props.current_song.id
    });

    player.on('load', () => {
      this.forceUpdate();
    });

    player.on('play', () => {
      this.playerMap[audio.id].played = true;
      this.setState({ paused: false });
    });

    player.on('end', () => {
      this.setState({ paused: true });
    });

    player.on('pause', () => {
      this.setState({ paused: true });
    });

    player.on('stop', () => {
      this.setState({ paused: true });
    });

    return player;
  }

	render() {
    const height = 34;
    let currentTime = this.currentPlayer == null ? 0 : this.currentPlayer.seek();
    if (isNaN(currentTime)) { currentTime = 0; }
    let duration = this.currentPlayer == null ? 0 : this.currentPlayer.duration();
    if (isNaN(duration)) { duration = 0; }
    let seconds = Math.floor(currentTime % 60) + '';
    if (seconds.length < 2) { seconds = '0' + seconds; }
    let minutes = Math.floor(currentTime / 60) + '';
    if (minutes.length < 2) { minutes = '0' + minutes; }
    const formattedCurrentTime = minutes + ':' + seconds;
    const currentPercentage = duration === 0 ? 
      0 : (currentTime / duration * 100);
    const playImage = this.currentPlayer !== null && this.currentPlayer.state() !== 'loaded' ? imageLoadButton : this.state.paused ? imagePlayButton : imagePauseButton;
    const playCss = this.currentPlayer !== null && this.currentPlayer.state() !== 'loaded' ? 
    { 'transform' : 'rotate('+ this.state.degrees +'deg)', width: 34, height: 34 } : 
    { width: 34, height: 34 };

		return (
      <div style={{
        position: 'relative'
      }}>
      <div style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          backgroundColor: '#F1F0F0',
          zIndex: -2
        }}/>
        <div style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          backgroundColor: '#E3E2E2',
          width: currentPercentage + '%',
          zIndex: -1
        }}/>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          height: 60,
          paddingLeft: 8,
          paddingRight: 8,
        }}>
          <input alt=""
          type="image" 
          src={ playImage } 
          onClick={this.onPlay} 
          style={playCss}/>
          <div style={{
            height: 3,
            backgroundColor: '#C0C0C0',
            flex: 1
          }}></div>
          <div style={{
            height: height,
            width: 72,
            backgroundColor: '#C0C0C0',
            borderRadius: height / 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{
              fontSize: 20,
              color: '#F1F0F0'
            }}>{formattedCurrentTime}</span>
          </div>
        </div>
      </div>
    );
	}
}

export default Audio;


// WEBPACK FOOTER //
// ./src/components/music/audio.jsx